// react
import { useNavigate, useLocation } from 'react-router-dom';

// components
import { AdminInviteSentPage } from '@karehero/llama/pwa/pages/AdminInviteSentPage/AdminInviteSentPage';

// hooks
import { useGoBack } from 'hooks/useGoBack';

// store
import { useGetSessionOrganizationQuery } from 'store/api/organization';

// router
import { ROUTES } from 'router';

/**
 * AdminInviteSent wires the AdminInviteSentPage back to the portal
 */
export const AdminInviteSent = () => {
  const navigate = useNavigate();
  const goBack = useGoBack();
  const location = useLocation();
  const { data: organization } = useGetSessionOrganizationQuery();

  const {
    firstName = '',
    lastName = '',
    email = '',
  } = (location.state || {}) as {
    firstName?: string;
    lastName?: string;
    email?: string;
  };

  return (
    <AdminInviteSentPage
      onBack={goBack}
      firstName={firstName}
      lastName={lastName}
      email={email}
      organizationName={organization?.name || ''}
      onInviteAnother={() =>
        navigate(ROUTES.PORTAL_ADMIN_INVITE, { replace: true })
      }
      onDone={() => navigate(ROUTES.PORTAL, { state: { back: true } })}
    />
  );
};

export default AdminInviteSent;
